import Hotjar from "../components/Hotjar";
import User from "../components/User";
import Posts from "../components/Posts";
import UserProfile from "../components/UserProfile";

const Home = () => {
    return(
        <>
            <Hotjar />
            <User />
            <Posts />
            <UserProfile />
        </>
    )
}

export default Home;